import { Fragment, useCallback, useContext, useEffect, useState } from "react";
import {
  Button,
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { baseURL, customIcons } from "../constants";
import * as MuiIcons from "@mui/icons-material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import usePopup from "../hooks/usePopup";
import { useNavigate } from "react-router-dom";
import moduleRoutes from "../routes/moduleRouteList";
import patientCareRouteList from "../PatientCare/routeList";
import { HL7ContexTriggerContex } from "../context/HL7MessageTrigger/HL7MessageTriggerProvider";
import { useQuery } from "react-query";
import { getPivilegesServices } from "../services/services";
import { Authentication } from "../Authentication/context/AuthenticationProvider";
import { storageKey } from "../utilis/methods/storage/storage";
import {
  AuthenticationContextType,
  PermissionsType,
} from "../Types/Authentication/AuthenticationTypes";
import MenuSkeleton from "./MenuSkeleton";
const listTextSize = "clamp(8px, 1.2vw, 12px)";
const base = (window as any)._env_?.BASE_URL;
function SideBarComponent({ isOpen = true }: { isOpen?: boolean }) {
  const currentPath = location.pathname;
  const { triggerApi } = useContext(HL7ContexTriggerContex);
  const {
    permissions,
    setPermissions,
    isAuthenticated,
    setRefetchPermission,
    refetchPermissions,
  } = useContext(Authentication) as AuthenticationContextType;
  const navigateTo = useNavigate();
  const { showSnackbar, CustomModal } = usePopup();
  const [openMenuId, setOpenMenuId] = useState<{[key:number]:boolean}>({});
  // const [allMenu, setAllMenu] = useState<any[]>([]);
  const [open, setOpen] = useState(false);
  const [nextPath, setNextPath] = useState<string>("");

  const { isLoading: privilageLoading } = useQuery(
    ["getAllUserPrivileges", refetchPermissions],
    getPivilegesServices,
    {
      enabled: refetchPermissions,
      refetchOnWindowFocus: false,
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          localStorage.setItem(
            storageKey.data,
            JSON.stringify(result?.response?.permissions || [])
          );
          setPermissions(result?.response?.permissions || []);
          setRefetchPermission(false);
        } else {
          showSnackbar({
            message: "Something went ",
            open: true,
            variant: "warning",
            duration: 2000,
          });
        }
      },
      onError: () => {
        showSnackbar({
          message: "Something went ",
          open: true,
          variant: "warning",
          duration: 2000,
        });
      },
    }
  );

  const handleNavigate = (path: string) => {
    const moduleRoute = moduleRoutes.patientCare;
    const pageRoute = patientCareRouteList.emr;
    const insideEmr = currentPath.includes(`/${moduleRoute}/${pageRoute}/`);
    triggerApi();
    if (insideEmr) {
      setOpen(true);
      setNextPath(path);
    } else {
      if (path.includes("ui")) {
        navigateTo(`${base}${path}`);
      } else {
        location.href = `${baseURL}angular/#${path}`;
      }
    }
  };

  const handleExitEmr = () => {
    if (nextPath.includes("ui")) {
      navigateTo(`${base}${nextPath}`);
    } else {
      location.href = `${baseURL}angular/#${nextPath}`;
    }
    setOpen(false);
  };

  const handleOpen = (menuId: number) => {
    // setOpenMenuId(openMenuId === menuId ? -1 : menuId);
    setOpenMenuId(prev=>{
        if(Boolean(prev[menuId])){
           return {...prev,[menuId]:false}
        }else{
           return {...prev,[menuId]:true}
        }
    });
  };

  const IconComponent = ({
    icon,
  }: {
    icon: keyof typeof customIcons | string | undefined;
  }) => {
    const iconKey = icon ? customIcons[icon as keyof typeof customIcons] : null;
    const SelectedIcon = iconKey
      ? MuiIcons[iconKey as keyof typeof MuiIcons]
      : MuiIcons[icon as keyof typeof MuiIcons] || MuiIcons.FiberManualRecord;
    return <SelectedIcon sx={{ fontSize: 20 }} />;
  };

  const handleCheckActive = useCallback(
    (page: string): boolean => {
      try {
        const splited = location.pathname.split("/");
        const pathSplited = page?.split("/") || [];
        return Boolean(
          splited[splited.length - 1] === pathSplited[pathSplited.length - 1]
        );
      } catch (_: any) {
        return false;
      }
    },
    [location.pathname]
  );

  const renderMenu = (menuList: PermissionsType[]) => {
    if (!Boolean(menuList?.length)) return null;
    return menuList?.map((menu) => {
      const isActive = handleCheckActive(menu?.page || "");
      if (Boolean(menu?.parentId) && !Boolean(menu?.children?.length)) {
        return (
          <ListItem
            key={`menu${menu.id}`}
            sx={{ display: "block" }}
            disablePadding
          >
            <ListItemButton
              onClick={() => handleNavigate(menu?.page || "")}
              sx={(theme) => ({
                paddingY: 1,
                paddingLeft: 2.5,
                backgroundColor: isActive
                  ? theme.palette.action.selected
                  : "transparent",
                "&:hover": {
                  backgroundColor: theme.palette.action.hover,
                },
              })}
            >
              <ListItemIcon
                sx={(theme) => ({
                  minWidth: 0,
                  padding: 0,
                  color: isActive
                    ? theme.palette.sideBarColor.A100
                    : theme.palette.sideBarColor.contrastText,
                })}
              >
                <IconComponent icon={menu.icon as keyof typeof customIcons} />
              </ListItemIcon>
              {isOpen && (
                <ListItemText
                  primary={
                    <Typography
                      // fontWeight={checkReport(menu) ? "bold" : "normal"}
                      // fontSize={checkReport(menu) ? "13px" : "12px"}
                      fontSize={listTextSize}
                    >
                      {menu.name}
                    </Typography>
                  }
                  sx={(theme) => ({
                    width: "20%",
                    color: isActive
                      ? theme.palette.sideBarColor.A100
                      : theme.palette.sideBarColor.contrastText,
                    marginLeft: 1,
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    fontSize: "12px",
                  })}
                />
              )}
            </ListItemButton>
          </ListItem>
        );
      } else {
        return (
          <Fragment key={`menuofsubmenu${menu.id}`}>
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => handleOpen(menu?.id || 0)}
                sx={{
                  paddingY: 1,
                  paddingLeft: 2.5,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <ListItemIcon
                  sx={(theme) => ({
                    minWidth: 0,
                    padding: 0,
                    color: theme.palette.sideBarColor.contrastText,
                  })}
                >
                  <IconComponent icon={menu.icon as keyof typeof customIcons} />
                </ListItemIcon>
                {isOpen && (
                  <ListItemText
                    primary={
                      <Typography fontSize={listTextSize}>
                        {menu.name}
                      </Typography>
                    }
                    sx={(theme) => ({
                      color: theme.palette.sideBarColor.contrastText,
                      marginLeft: 1,
                    })}
                  />
                )}
                <div className={isOpen ? "" : "hidden"}>
                  {openMenuId[menu.id]  ? (
                    <ExpandLess
                      sx={(theme) => ({
                        color: theme.palette.sideBarColor.contrastText,
                      })}
                    />
                  ) : (
                    <ExpandMore
                      sx={(theme) => ({
                        color: theme.palette.sideBarColor.contrastText,
                      })}
                    />
                  )}
                </div>
              </ListItemButton>
            </ListItem>
            <Collapse in={openMenuId[menu.id]} timeout="auto" unmountOnExit>
              <List sx={{ paddingLeft: "8px" }} component="div" disablePadding>
                {renderMenu(menu.children)}
              </List>
            </Collapse>
          </Fragment>
        );
      }
    });
  };

  useEffect(() => {
    if (isAuthenticated) {
      try {
        const data = JSON.parse(localStorage.getItem(storageKey.data) || "[]");
        if (Boolean(data?.length)) {
          setPermissions([...data]);
        } else {
          setRefetchPermission(true);
        }
      } catch (error) {
        showSnackbar({
          message: "Something went wrong! Please refresh",
          open: true,
          variant: "warning",
          duration: 2000,
        });
      }
    }
  }, [isAuthenticated]);

  return (
    <>
      <CustomModal title="Are you moving out?" open={open} setOpen={setOpen}>
        <div className="p-2 flex flex-col cont">
          <div className="w-[30vw] h-[10dvh] p-4">Do you want to exit EMR?</div>
          <div className="flex justify-end gap-2">
            <Button
              onClick={() => {
                setOpen(false);
              }}
              variant="text"
            >
              no
            </Button>
            <Button variant="text" color="warning" onClick={handleExitEmr}>
              Yes
            </Button>
          </div>
        </div>
      </CustomModal>
      {privilageLoading ? (
        <MenuSkeleton />
      ) : (
        <List sx={{ padding: 0 }}>
          {permissions.map((menu, i) => (
            <Fragment key={`section${menu.id} ${i}`}>
              <ListItem sx={{ paddingY: 0, marginRight: 0 }}>
                <ListItemText
                  primary={
                    <Typography
                      fontSize={listTextSize}
                      fontWeight={"600"}
                      className="text-xs uppercase"
                    >
                      {menu?.name}
                    </Typography>
                  }
                  sx={(theme) => ({
                    color: theme.palette.sideBarColor.light,
                  })}
                />
              </ListItem>
              {renderMenu(menu.children)}
            </Fragment>
          ))}
        </List>
      )}
    </>
  );
}

export default SideBarComponent;
